import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";

import SideModal from "../../SideModal";
import PropertyDocumentUploadModal from "./PropertyDocumentUploadModal";
import { capitalizeFirstLetter } from "../../../helpers";
import { BoxHead, Underline } from "../../Styles/PageStyles";
import NotFoundModel from "../../NotFoundModel";
import { AddBtn } from "../../Styles/InputStyles";

export default function PropertyDocuments({
  isDocumentAdd,
  setIsDocumentAdd,
  docs,
  uploadDocMutate,
  isDocLoading,
  inventoryId,
}) {
  const [data, setData] = useState(docs || []);

  useEffect(() => {
    setData(docs || []);
  }, [docs]);

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  return (
    <>
      <Wrapper>
        <BoxHead>
          <TabTitle className="!mb-0 whitespace-nowrap">
            Documents
            <Underline />
          </TabTitle>

          <AddBtn
            type="button"
            onClick={() => setIsDocumentAdd(true)}
          >
            Add Document
          </AddBtn>
        </BoxHead>

        {!data || data.length === 0 ? (
          // <div className="flex justify-center items-center py-10">
          //   <p className="text-gray-400 text-sm">
          //     No documents uploaded yet
          //   </p>
          // </div>
          <NotFoundModel msg={"No documents uploaded yet"} />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-4">
            {data.map((doc, index) => {
              const docDate =
                doc?.createdAt || doc?.updatedAt;

              return (
                <DocCard key={index}>
                  {/* Title */}
                  <span className="text-sm font-semibold text-gray-800">
                    {capitalizeFirstLetter(doc?.title || "Document")}
                  </span>

                  {/* Date */}
                  {docDate ? (
                    <span className="text-xs text-gray-400 mt-1">
                      {formatDate(docDate)}
                    </span>
                  ) : null}

                  {/* CTA */}
                  <a
                    href={doc?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 text-sm font-medium text-primary-color hover:underline"
                  >
                    View / Download
                  </a>
                </DocCard>
              );
            })}
          </div>
        )}
      </Wrapper>

      <SideModal
        isOpen={isDocumentAdd}
        onClose={() => setIsDocumentAdd(false)}
      >
        {/* <PropertyDocumentUploadModal
          handleClose={() => setIsDocumentAdd(false)}
          setIsDocumentAdd={setIsDocumentAdd}
          uploadDocMutate={uploadDocMutate}
          isDocLoading={isDocLoading}
          propId={propId}
        /> */}
        <PropertyDocumentUploadModal
          handleClose={() => setIsDocumentAdd(false)}
          setIsDocumentAdd={setIsDocumentAdd}
          uploadDocMutate={uploadDocMutate}
          isDocLoading={isDocLoading}
          inventoryId={inventoryId}
        />
      </SideModal>
    </>
  );
}

const Wrapper = tw.div`px-4 space-y-4 mt-2`;

const DocCard = tw.div`
flex flex-col items-start 
bg-white border border-gray-200 
p-4 rounded-xl shadow-sm 
hover:shadow-md transition-all duration-200
`;

export const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;



const TabTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;
